import {
  ApolloClient,
  ApolloProvider,
  NormalizedCacheObject,
} from '@apollo/client';
import { Suspense } from 'react';
import { Navigate } from 'react-router-dom';

import { EluveAdminOnly } from '@eluve/smart-blocks';

import { AdminExportAppointmentsPage } from './AdminExportAppointmentsPage';
import {
  DraftContent,
  EhrDiffContent,
  EhrDraftContent,
  SummaryContent,
  SummaryDiffContent,
  SummaryViewToggle,
} from './AppointmentArtifacts';
import { AppointmentTranscripts } from './AppointmentTranscripts';
import { ReviewAppointmentLayout } from './ReviewAppointmentLayout';
import { ReviewAppointmentsPage } from './ReviewAppointmentsPage';
import { ReviewDashGuard } from './ReviewDashGuard';
import { ReviewFeedbackPage } from './ReviewFeedbackPage';
import { ReviewLayout } from './ReviewLayout';

export const reviewAppointmentDetailsRoutes = [
  {
    index: true,
    element: <Navigate to="transcripts" replace />,
  },
  {
    path: 'transcripts',
    element: <AppointmentTranscripts />,
  },
  {
    path: 'summary',
    element: <SummaryContent />,
  },
  {
    path: 'golden-summary',
    element: <SummaryViewToggle />,
  },
  {
    path: 'draft',
    element: <DraftContent />,
  },
  {
    path: 'summary-diff',
    element: <SummaryDiffContent />,
  },
  {
    path: 'ehr-diff',
    element: <EhrDiffContent />,
  },
  {
    path: 'ehr-draft',
    element: <EhrDraftContent />,
  },
];

export const reviewAppointmentDetailsTabNav = [
  { name: 'Transcript', link: 'transcripts' },
  { name: 'Summary', link: 'summary' },
  { name: 'Golden Summary', link: 'golden-summary' },
  {
    name: 'Doctor Draft',
    link: 'draft',
  },
  {
    name: 'Summary Diff',
    link: 'summary-diff',
  },
  {
    name: 'EHR Diff',
    link: 'ehr-diff',
  },
  {
    name: 'EHR Draft',
    link: 'ehr-draft',
  },
];

export const createReviewRoutes = (
  path: string,
  client: ApolloClient<NormalizedCacheObject>,
) => {
  return [
    {
      path,
      element: (
        <ReviewDashGuard>
          <ApolloProvider client={client}>
            <Suspense>
              <ReviewLayout />
            </Suspense>
          </ApolloProvider>
        </ReviewDashGuard>
      ),
      children: [
        {
          index: true,
          element: <Navigate to="appointments" replace />,
        },
        {
          path: 'appointments',
          element: <ReviewAppointmentsPage />,
        },
        {
          path: 'admin/export',
          element: (
            <EluveAdminOnly>
              <AdminExportAppointmentsPage />
            </EluveAdminOnly>
          ),
        },
        {
          path: 'appointments/:tenantId/:appointmentId',
          element: <ReviewAppointmentLayout showTools />,
          children: reviewAppointmentDetailsRoutes,
        },
        {
          path: 'feedback',
          element: <ReviewFeedbackPage />,
        },
      ],
    },
  ];
};
